import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/inactive/Breadcrumb";
import DepositByUserLayer from "../components/DepositByUserLayer";

const DepositByUserPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Invoice - List" />

        {/* InvoiceListLayer */}
        <DepositByUserLayer />
      </MasterLayout>
    </>
  );
};

export default DepositByUserPage;
